<div class="page-header-outer">        
    <div class="page-header">
        <h1>Client Impersonation</h1>
    </div>
</div>
<div class="content-inner">   
    <section>
        <div class="form-group" >
            <label>Clients</label> 
            <select name="client" *ngIf="client" [ngModel]="client.id" (change)="onClientChange($event.target.value)">
                <option *ngFor="let client of clients" [value]="client.id" [disabled]="client.disabled">{{ client.name }}</option>                  
            </select>
            <br><br><h3>You are now viewing <b>{{ client == null || client == undefined ? '' : client.name }}</b> data.</h3>
        </div>
    </section>
</div>